module.exports = __webpack_public_path__ + "static/media/playlistCoverArtifact.7f5b71d1.svg";